import type { Position } from 'geojson';

import { MAP_EVENT_TYPE } from './constants';
import type { MapEvent, MapVertexChangedEventData } from './types';

const createMapVertexChangedEvent = (
    vertexPosition: Position
): MapEvent<MapVertexChangedEventData> =>
    new CustomEvent<MapVertexChangedEventData>(MAP_EVENT_TYPE.MAP_VERTEX_CHANGED, {
        detail: {
            vertexPosition
        }
    });

export default {
    createMapVertexChangedEvent
};
